export interface UiState {
    isLoading: boolean;
    locale: string;
    isLevelLocked: boolean;
}
